// Helper function to get feature value from backend API (synchronous)
export const getFeatureValue = (featureKey, defaultValue = false, sourceValue = null) => {
  try {
    let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
    
    const params = new URLSearchParams();
    params.append('featureKey', featureKey);
    if (sourceValue) {
      params.append('source', sourceValue);
    }

    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${url}/common/feature?${params}`, false); // false makes it synchronous
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'By-Pass-Auth-Create-Prospect');
    
    xhr.send();

    if (xhr.status === 200) {
      const featureFlag = JSON.parse(xhr.responseText);
      return featureFlag.value !== undefined ? featureFlag.value : defaultValue;
    } else {
      console.warn(`Error getting feature '${featureKey}': ${xhr.status} ${xhr.statusText}`);
      return defaultValue;
    }
  } catch (error) {
    console.warn(`Error getting feature '${featureKey}':`, error);
    return defaultValue;
  }
};
